export const API_URL =
  process.env.REACT_APP_API_URL !== undefined ? process.env.REACT_APP_API_URL : "http://localhost:8080";
export const PHOTO_URL = `${API_URL}/public/files/`;
export const RECAPTCHA_KEY = "6LeFLbkUAAAAAGDpBVYlTB_hRfHgz2tIDDo7l3IY";
